module.exports = __webpack_public_path__ + "static/hero-finance-04ce757f9a7866d3cac09cd8fdbd3ed4.png";